import React from "react";
import { motion } from "framer-motion";
import "../css/home.css";
import CustomButton from "../widget/customButton";
import { Link } from "react-scroll";
import cv from "../constants/Latest CV.pdf";

export const Home = () => (
  <section className="hero-section" id="home">
    <motion.div
      className="hero-content"
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.72, ease: "easeOut" }}
    >
      <div className="eyebrow">Full-Stack Software Developer</div>
      <h1>
        <span className="intro-prefix">Hi, I’m</span>
        <span className="primary-name">Makite Desta</span>
      </h1>
      <p className="hero-role">
        Building secure, scalable, and user-focused digital products.
      </p>
      <p className="hero-description">
        I design and build fintech platforms, ERP systems, mobile banking apps,
        and modern web applications for high-impact teams — from Ethiopia to
        international organizations.
      </p>

      <div className="hero-metrics">
        <motion.div whileHover={{ y: -4, scale: 1.01 }}>
          <strong>4+</strong>
          <span>Years experience</span>
        </motion.div>
        <motion.div whileHover={{ y: -4, scale: 1.01 }}>
          <strong>20+</strong>
          <span>Projects</span>
        </motion.div>
        <motion.div whileHover={{ y: -4, scale: 1.01 }}>
          <strong>5</strong>
          <span>Core tech domains</span>
        </motion.div>
      </div>

      <div className="action-row">
        <Link spy smooth to="contact" duration={260} offset={-90}>
          <div className="get-in-touch-btn">
            <CustomButton text="Get In Touch" />
          </div>
        </Link>
        <a href={cv} download>
          <div className="download-cv-btn">
            <CustomButton text="Download CV" />
          </div>
        </a>
      </div>
    </motion.div>

    <motion.div
      className="hero-visual"
      aria-label="Makite Desta profile"
      initial={{ opacity: 0, x: 30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.1, ease: "easeOut" }}
    >
      <div className="profile-card profile-card-image">
        <img src="/meku.png" alt="Makite Desta" className="hero-portrait" />
        <div className="profile-badge">Available for opportunities</div>
        <ul>
          <li>Fintech,Telecom & Banking Systems</li>
          <li>ERP & Business Platforms</li>
          <li>Web & Mobile Product Development</li>
          <li>DevOps</li>
        </ul>
      </div>
    </motion.div>
  </section>
);
